"use client";

export type { TrackEvent } from "./analytics-client-boundary";
export { useTrackEvent } from "./analytics-client-boundary";
